export const SET_FEATURED_EVENT = 'SET_FEATURED_EVENT';

export const setFeaturedEvent = (eventId, nextRotationAt) => ({
  type: SET_FEATURED_EVENT,
  payload: { eventId, nextRotationAt },
});
